<app-side-drawer-container>
  <!--OnScroll will callback if the infiniteScrollDistance threshold has been reached on a scroll down -->
  <!--infiniteScrollDistance is the number of viewport lengths from the bottom of the page at which the event will be triggered-->
  <!--scrollWindow(Default true) listens to the window scroll instead of the actual element scroll-->
  <div
    #mainPageContainer
    class="ng-component-container"
    infiniteScroll
    [infiniteScrollDistance]="2"
    [scrollWindow]="false"
    [infiniteScrollThrottle]="50"
    (scrolled)="emitLoadMore()"
    (scroll)="onWindowScroll()"
  >
    <div class="ng-partner-central-standard-width">
      <va-breadcrumbs *ngIf="breadcrumbs" [breadcrumbs]="breadcrumbs"></va-breadcrumbs>
      <div class="title-container">
        <div class="page-title-container">
          <h1 class="page-title">{{ pageTitle | translate }}</h1>
          <va-badge *ngIf="badgeText" [color]="badgeColor">
            {{ badgeText }}
          </va-badge>
        </div>
        <ng-content select="[buttons-adjacent]"></ng-content>

        <a
          class="header-button"
          *ngFor="let button of secondaryButtons"
          mat-button
          matTooltip="{{ button.tooltip }}"
          [color]="button.warn ? 'warn' : 'primary'"
          [id]="button.buttonId"
          [routerLink]="button.url"
          [queryParams]="button.queryParams"
          [target]="button.openNewTab ? '_blank' : '_self'"
          [ngClass]="button.cssClasses"
          (click)="clicked(button)"
        >
          <mat-icon *ngIf="button.icon">{{ button.icon }}</mat-icon>
          {{ button.title | translate }}
        </a>

        <ng-container *ngFor="let button of primaryButtons">
          <ng-container
            *ngTemplateOutlet="
              showTooltipOnDisabledButton(button) ? disabledButtonWithTooltip : primaryButtonTemplate;
              context: { button: button }
            "
          ></ng-container>

          <ng-template #disabledButtonWithTooltip let-button="button">
            <div [glxyTooltip]="button.disabledTooltip">
              <ng-container *ngTemplateOutlet="primaryButtonTemplate; context: { button: button }"></ng-container>
            </div>
          </ng-template>

          <ng-template #primaryButtonTemplate let-button="button">
            <a
              class="header-button"
              mat-raised-button
              *ngIf="!!button.url"
              matTooltip="{{ button.tooltip }}"
              [color]="button.warn ? 'warn' : 'primary'"
              [id]="button.buttonId"
              [routerLink]="button.url"
              [target]="button.openNewTab ? '_blank' : '_self'"
              [ngClass]="button.cssClasses"
              (click)="clicked(button)"
            >
              <mat-icon *ngIf="button.icon">{{ button.icon }}</mat-icon>
              {{ button.title | translate }}
            </a>
            <button
              class="header-button"
              mat-raised-button
              *ngIf="!button.url"
              matTooltip="{{ button.tooltip }}"
              [color]="button.warn ? 'warn' : 'primary'"
              [id]="button.buttonId"
              [ngClass]="button.cssClasses"
              [disabled]="button.disabled"
              (click)="clicked(button)"
            >
              <mat-icon *ngIf="button.icon">{{ button.icon }}</mat-icon>
              {{ button.title | translate }}
            </button>
          </ng-template>
        </ng-container>

        <mat-menu #tertiary="matMenu">
          <ng-template matMenuContent>
            <a
              class="header-button"
              style="color: inherit"
              *ngFor="let button of tertiaryButtons"
              mat-menu-item
              matTooltip="{{ button.tooltip }}"
              [id]="button.buttonId"
              [routerLink]="button.url"
              [target]="button.openNewTab ? '_blank' : '_self'"
              [ngClass]="button.cssClasses"
              (click)="clicked(button)"
            >
              <mat-icon *ngIf="button.icon">{{ button.icon }}</mat-icon>
              {{ button.title | translate }}
            </a>
          </ng-template>
        </mat-menu>
        <ng-container *ngIf="pageSideHelpId">
          <button
            class="page-help"
            mat-icon-button
            (click)="pageHelpToggle()"
            [ngClass]="{ 'page-help-opened': helpOpened$ | async }"
          >
            <mat-icon cdkOverlayOrigin #popoverOrigin="cdkOverlayOrigin">help_outline</mat-icon>
          </button>
          <glxy-popover
            [origin]="popoverOrigin"
            [isOpen]="showPopover$ | async"
            [positions]="[PopoverPositions.BottomRight]"
            [padding]="'small'"
            [highContrast]="true"
            [hasBackdrop]="true"
            [showBackdrop]="false"
            (backdropClick)="hide()"
          >
            {{ 'PAGE.HELP_ONE_TIME_POPOVER' | translate }}
          </glxy-popover>
        </ng-container>
        <button mat-icon-button color="primary" [matMenuTriggerFor]="tertiary" *ngIf="tertiaryButtons.length > 0">
          <mat-icon>more_vert</mat-icon>
        </button>
      </div>
      <h2 *ngIf="pageSubtitle" class="page-subtitle">
        {{ pageSubtitle }}
        <a *ngIf="showSubtitleLink()" target="_blank" href="{{ pageSubtitleLink }}">
          {{ pageSubtitleLinkText }}
        </a>
      </h2>
      <ng-content></ng-content>
    </div>
  </div>
</app-side-drawer-container>
